import { render, staticRenderFns } from "./place-notification-form-page.vue?vue&type=template&id=ebf5a4fe&scoped=true&"
import script from "./place-notification-form-page.vue?vue&type=script&lang=js&"
export * from "./place-notification-form-page.vue?vue&type=script&lang=js&"
import style0 from "./place-notification-form-page.vue?vue&type=style&index=0&id=ebf5a4fe&lang=scss&scoped=true&"
import style1 from "./place-notification-form-page.vue?vue&type=style&index=1&id=ebf5a4fe&lang=scss&scoped=true&"
import style2 from "./place-notification-form-page.vue?vue&type=style&index=2&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ebf5a4fe",
  null
  
)

export default component.exports
import {QBreadcrumbs,QIcon,QBreadcrumbsEl,QTabs,QTab,QForm,QTabPanels,QTabPanel,QInput,QBtn,QSpinnerIos,QField} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QBreadcrumbs,QIcon,QBreadcrumbsEl,QTabs,QTab,QForm,QTabPanels,QTabPanel,QInput,QBtn,QSpinnerIos,QField})
